import { render, staticRenderFns } from "./SupportShortendMessageCell.vue?vue&type=template&id=3aa1b4e4&scoped=true&"
import script from "./SupportShortendMessageCell.vue?vue&type=script&lang=js&"
export * from "./SupportShortendMessageCell.vue?vue&type=script&lang=js&"
import style0 from "./SupportShortendMessageCell.vue?vue&type=style&index=0&id=3aa1b4e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa1b4e4",
  null
  
)

export default component.exports